import React from 'react';
import { ReactComponent as CookingIcon } from '../assets/hobby-icons/cooking.svg';
import { ReactComponent as MoviesIcon } from '../assets/hobby-icons/movies.svg';
import { ReactComponent as TVShowsIcon } from '../assets/hobby-icons/tvshows.svg';
import { ReactComponent as ReadingIcon } from '../assets/hobby-icons/reading.svg';
import { ReactComponent as TravelingIcon } from '../assets/hobby-icons/traveling.svg';
import { ReactComponent as HikingIcon } from '../assets/hobby-icons/hiking.svg';
import { ReactComponent as FitnessIcon } from '../assets/hobby-icons/fitness.svg';
import { ReactComponent as FitnessRoutineIcon } from '../assets/hobby-icons/fitness-routine.svg';
import { ReactComponent as FitnessWorkoutIcon } from '../assets/hobby-icons/fitness-workout.svg';
import { ReactComponent as FitnessActivityIcon } from '../assets/hobby-icons/fitness-activity.svg';
import { ReactComponent as HobbyIcon } from '../assets/hobby-icons/hobby.svg';
import { ReactComponent as MusicIcon } from '../assets/hobby-icons/music.svg';
import { ReactComponent as DiningIcon } from '../assets/hobby-icons/dining.svg';
import { ReactComponent as CreativeIcon } from '../assets/hobby-icons/creative.svg';

export const hobbyMediaStyles = {
  dining: { label: 'Dining', accent: '#c58b24', darkBackground: '#282010', lightBackground: '#faf0dc', aliases: ['diningplace', 'diningvisit'] },
  music: { label: 'Music Moments', accent: '#db2777', darkBackground: '#301020', lightBackground: '#fce7f3', aliases: ['musicmoment'] },
  creative: { label: 'Creative Projects', accent: '#a855f7', darkBackground: '#251531', lightBackground: '#f3e8ff', aliases: ['creativeproject'] },
  cooking: {
    label: 'Cooking',
    accent: '#f97316',
    darkBackground: '#2a1608',
    lightBackground: '#fff1e7',
    aliases: ['recipe', 'recipes'],
  },
  movies: {
    label: 'Movies',
    accent: '#8b5cf6',
    darkBackground: '#1d1238',
    lightBackground: '#f1ecff',
    aliases: ['movie'],
  },
  tvshows: {
    label: 'TV Shows',
    accent: '#2563eb',
    darkBackground: '#0b1a3f',
    lightBackground: '#eaf1ff',
    aliases: ['tv', 'tv shows', 'show', 'series'],
  },
  reading: {
    label: 'Reading',
    accent: '#0891b2',
    darkBackground: '#072531',
    lightBackground: '#e4f8fc',
    aliases: ['book', 'books'],
  },
  traveling: {
    label: 'Traveling',
    accent: '#16a34a',
    darkBackground: '#082814',
    lightBackground: '#e8f8ee',
    aliases: ['travel', 'trip', 'trips'],
  },
  hiking: {
    label: 'Hiking',
    accent: '#84cc16',
    darkBackground: '#172907',
    lightBackground: '#f0f9dc',
    aliases: ['hike', 'trail', 'trails'],
  },
  fitness: {
    label: 'Fitness',
    accent: '#14b8a6',
    darkBackground: '#062b28',
    lightBackground: '#e3fbf7',
    aliases: ['workout', 'activity'],
  },
  'fitness-routine': {
    label: 'Routine',
    accent: '#14b8a6',
    darkBackground: '#062b28',
    lightBackground: '#e3fbf7',
    aliases: ['routine'],
  },
  'fitness-workout': {
    label: 'Workout',
    accent: '#14b8a6',
    darkBackground: '#062b28',
    lightBackground: '#e3fbf7',
    aliases: ['structured workout'],
  },
  'fitness-activity': {
    label: 'Activity',
    accent: '#14b8a6',
    darkBackground: '#062b28',
    lightBackground: '#e3fbf7',
    aliases: ['fitness activity'],
  },
  hobby: {
    label: 'Hobby',
    accent: '#22d3ee',
    darkBackground: '#092531',
    lightBackground: '#e6fbff',
    aliases: [],
  },
};

const aliasToHobbyId = Object.entries(hobbyMediaStyles).reduce((map, [id, style]) => {
  map[id] = id;
  style.aliases.forEach((alias) => {
    map[alias] = id;
  });
  return map;
}, {});

export function normalizeHobbyMediaId(value) {
  const key = String(value || 'hobby').trim().toLowerCase();
  return aliasToHobbyId[key] || 'hobby';
}

export function getHobbyMediaStyle(value) {
  return hobbyMediaStyles[normalizeHobbyMediaId(value)];
}

export function hobbyMediaClassName(value) {
  return `fallback-${normalizeHobbyMediaId(value)}`;
}

export function HobbyMediaIcon({ type = 'hobby', className = '' }) {
  const id = normalizeHobbyMediaId(type);
  const Icon = {
    dining: DiningIcon,
    creative: CreativeIcon,
    music: MusicIcon,
    cooking: CookingIcon,
    movies: MoviesIcon,
    tvshows: TVShowsIcon,
    reading: ReadingIcon,
    traveling: TravelingIcon,
    hiking: HikingIcon,
    fitness: FitnessIcon,
    'fitness-routine': FitnessRoutineIcon,
    'fitness-workout': FitnessWorkoutIcon,
    'fitness-activity': FitnessActivityIcon,
    hobby: HobbyIcon,
  }[id] || HobbyIcon;

  return <Icon
    className={`default-media-icon ${className}`.trim()}
    focusable="false"
    aria-hidden="true"
  />;
}
